module.exports = __webpack_public_path__ + "static/media/universe-wordmark.43494868.svg";